import { useRef } from 'react';
import { useOverlayTrigger } from 'react-aria';
import type { DialogTriggerProps } from 'react-aria-components';
import { OverlayTriggerStateContext, Provider, RootMenuTriggerStateContext } from 'react-aria-components';
import { useMenuTriggerState } from 'react-stately';
import { DialogContext, PopoverContext } from '@launchpad-ui/components';
import { PressResponder } from '@react-aria/interactions';

import styles from './TagDialogTrigger.module.css';

interface TagDialogTriggerProps extends DialogTriggerProps {}

export function TagDialogTrigger(props: TagDialogTriggerProps) {
  const state = useMenuTriggerState(props);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { triggerProps, overlayProps } = useOverlayTrigger({ type: 'dialog' }, state, buttonRef);

  return (
    <Provider
      values={[
        [OverlayTriggerStateContext, state],
        [RootMenuTriggerStateContext, state],
        [
          PopoverContext,
          { trigger: 'DialogTrigger', triggerRef: buttonRef, placement: 'bottom', className: styles.popover },
        ],
        [DialogContext, { ...overlayProps, className: styles.dialog }],
      ]}
    >
      <PressResponder {...triggerProps} ref={buttonRef} isPressed={state.isOpen}>
        {props.children}
      </PressResponder>
    </Provider>
  );
}
